
<div class="form-group product__option flex flex-row justify-center" fxLayouutAlign="center center" >
    <div class="form-group flex flex-col justify-around" fxLayouutAlign="space-around center">

        <div class="flex flex-row m-6" style="font-size: large;">{{'select_time_range' | translate}}</div>
        <div class="flex flex-row items-center justify-between" >
            <mat-label>{{'time_from' | translate}}:</mat-label>
            <app-custom-time-field [form]="time.get('start')" [availableFrom]="availableFrom" [availableTo]="startMax" class="mx-1"></app-custom-time-field>
        </div>

        <div class="flex flex-row items-center justify-between">
            <mat-label>{{'time_to' | translate}}:</mat-label>
            <app-custom-time-field [form]="time.get('end')" [availableFrom]="endMin" [availableTo]="availableTo" class="mx-1"></app-custom-time-field>
        </div>
    </div>
</div>

